<template>
  <div>
    <!-- 处理商品 -->
    <el-dialog :title="$t('message.processProducts')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="488px" center>
      <div class="content">
        <el-radio v-model="datas.discard_type" label="废弃">废弃</el-radio>
        <el-radio v-model="datas.discard_type" label="变现">变现</el-radio>
        <el-radio v-model="datas.discard_type" label="捐赠">捐赠</el-radio>
        <el-radio v-model="datas.discard_type" label="福利">福利</el-radio>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">{{
          $t("message.submit")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      datas: {
        stock_id: '',
        discard_type: '废弃',
      },
    };
  },
  methods: {
    // 保存
    save() {
      this.$api.warehouseApi.discardDealTypeSet(this.datas).then(res => {
        this.dialogVisible = false
        this.$message.success(res.msg)
        this.$parent.tableData.forEach(item => {
          if (item.id == this.datas.stock_id) {
            item.discard_type = this.datas.discard_type
          }
        })
        this.$forceUpdate()
      })
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;
  display: flex;

  .label {
    flex: 1;
    line-height: 40px;
  }

  .val {
    flex: 3;
  }
}
</style>